export { default as heroPropType } from './hero';
export { default as cardPropType } from './card';
export { default as blockquoteListPropType } from './blockquote-list';
export { default as splitScreenPropType } from './split-screen';
export { default as logoBoxPropType } from './logo-box';
export { default as highlightPanelPropType } from './highlight-panel';
export { default as pageLinkPropType } from './page-link';
export { default as signUpPanelPropType } from './sign-up-panel';
export { default as integrationCollagePropType } from './integration-collage';
